module.exports = __webpack_public_path__ + "static/media/map.e225cf6a.svg";